import { render, staticRenderFns } from "./ResetPass.vue?vue&type=template&id=06861f21&scoped=true"
import script from "./ResetPass.vue?vue&type=script&lang=js"
export * from "./ResetPass.vue?vue&type=script&lang=js"
import style0 from "./ResetPass.vue?vue&type=style&index=0&id=06861f21&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06861f21",
  null
  
)

export default component.exports